var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.handleConnect}},[_vm._v(_vm._s(_vm.connected ? _vm.shortAddr : _vm.wallet_addr))])}
var staticRenderFns = []

export { render, staticRenderFns }